import { Injectable } from '@angular/core';
import { AppointmentRequest } from '../../domain/models/appointment-request.model';
import { AppointmentRequestKind } from '../../domain/models/appointment-request-kind.model';
import { AppointmentRequestStatus } from '../../domain/models/appointment-request-status.model';
import { AppointmentRequestDto } from '../dtos/appointment-request.dto';

@Injectable()
export class AppointmentRequestMapper {
  public toAppointmentRequest(dto: AppointmentRequestDto): AppointmentRequest {
    return {
      id: dto.Id,
      clientExternalId: dto.ClientExternalId ?? null,
      patientExternalId: dto.PatientExternalId ?? null,
      clientName: dto.ClientName ?? '',
      patientName: dto.PatientName ?? '',
      reasonText: dto.ReasonText ?? '',
      requestedDate: dto.RequestedDate,
      requestedTime: dto.RequestedTime,
      status: this.resolveStatus(dto.Status),
      appointmentExternalId: dto.AppointmentExternalId ?? null,
      createdAtUtc: dto.CreatedAtUtc,
      kind: this.resolveKind(dto.Kind),
      sourceAppointmentExternalId: dto.SourceAppointmentExternalId ?? null,
    };
  }

  // 'confirmado' is the only live value; a retired one on a historical row degrades to it rather
  // than widening the type back out -- see AppointmentRequestStatus.
  private resolveStatus(value: string): AppointmentRequestStatus {
    return value === 'confirmado' ? value : 'confirmado';
  }

  private resolveKind(value: string | undefined): AppointmentRequestKind {
    if (value === 'modificacion' || value === 'cancelacion' || value === 'nueva') return value;
    return 'nueva';
  }
}
